import { Option, TranslationFunction } from '@/types';

export const tabs = [
  {
    label: 'customersSatisfactionReport',
    value: 'CustomersSatisfactionReport'
  },
  {
    label: 'statistics',
    value: 'Statistics'
  }
  // {
  //   label: 'customers',
  //   value: 'Customers'
  // }
];

export const defaultDataLineChart = {
  labels: [],
  datasets: [
    {
      label: 'Happy',
      data: [],
      backgroundColor: '#47987F',
      borderColor: '#47987F',
      borderWidth: 2,
      fill: false,
      hitRadius: 0,
      pointRadius: 0,
      radius: 0,
      tension: 0.1
    },
    {
      label: 'Ok',
      data: [],
      backgroundColor: '#F19E37',
      borderColor: '#F19E37',
      borderWidth: 2,
      fill: false,
      hitRadius: 0,
      pointRadius: 0,
      radius: 0,
      tension: 0.1
    },
    {
      label: 'Angry',
      data: [],
      backgroundColor: '#E2523F',
      borderColor: '#E2523F',
      borderWidth: 2,
      fill: false,
      hitRadius: 0,
      pointRadius: 0,
      radius: 0,
      tension: 0.1
    }
  ]
};

export const defaultDataBarChart = {
  labels: [],
  datasets: [
    {
      label: 'Number of users',
      data: [],
      backgroundColor: '#7f7f7f',
      borderWidth: 0
    }
  ]
};

export const columnsTemplates = ($t: TranslationFunction): Option[] => [
  {
    label: '',
    value: 'nameTemplates'
  },
  {
    label: $t('active'),
    value: 'active'
  },
  {
    label: $t('translation'),
    value: 'translation'
  }
];

export const activeOptions = ($t: TranslationFunction): Option[] => [
  {
    label: `${10} ${$t('minutes')}`,
    value: 10
  },
  {
    label: `${15} ${$t('minutes')}`,
    value: 15
  },
  {
    label: `${30} ${$t('minutes')}`,
    value: 30
  },
  {
    label: `${60} ${$t('minutes')}`,
    value: 60
  }
];
